document.addEventListener('turbolinks:load', () => {
  const $addTag = document.getElementById('add-tag');

  if($addTag) {
    $addTag.addEventListener('click', () => {
      const $addTagWrapper = document.getElementById('add-tag-wrapper');
      const $addTagSubmit = document.getElementById('add-tag-submit');
  
      $addTagWrapper.style.display = "flex";
      $addTag.style.display = "none";
  
      $addTagSubmit.addEventListener('click', () => {
        const $addTagInput = document.getElementById('add-tag-input');
        const $tagList = document.getElementById('tag-list');
        const option = document.createElement("option");

        option.value = $addTagInput.value;
        option.text = $addTagInput.value;

        $tagList.add(option, null);
        $tagList.setAttribute('size', $tagList.size + 1);
        $addTagInput.value = null;
      });
    });
  };
});